import { GridLayoutElement, GridLayouts } from 'adapter/in/dashboards/components/generic/ReactGrid';
import { ResponsiveReactGridLayoutProps } from 'adapter/in/dashboards/components/generic/ReactGrid/ResponsiveReactGridLayout';
import { LayoutType } from 'domain/entity/layout';

// Returns the breakpoint that ReactGridLayout is currently using.
export const getCurrentBreakpoint = (layouts: GridLayouts, passedProps: any): string => passedProps?.breakpoint || Object.keys(layouts)[0];

// Determine whether the current breakpoint is A4.
export const isA4Breakpoint = (bp: string): boolean => bp === LayoutType.A4;

// Computes the amount of rows that the layout occupies vertically.
export const computeLayoutRows = (layout: GridLayoutElement[]): number =>
    layout.length === 0 ? 0 : Math.max(...layout.map((item) => item.y + item.h));

// Returns the vertical margin between rows (in pixels).
export const getMarginY = (margin: ResponsiveReactGridLayoutProps['margin']): number => {
    if (typeof margin === 'number') return margin;
    if (Array.isArray(margin)) return margin[1];
    return 0;
};

// Computes the pixel positions of page breaks.
export const computePageBreakPositions = (totalPages: number, rowPx: number, rowsPerPage: number): number[] =>
    Array.from({ length: totalPages }).map((_, i) => (i + 1) * rowsPerPage * rowPx);
